import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'

import PrivateRoute from 'components/routes/Private'
import ThemeComponent from 'containers/App/Theme/index'
import App from 'containers/App/App/index'

// User Page
import LoginPage from 'containers/User/Login/index'

export default class Routes extends Component {
  render() {
    return (
      <ThemeComponent>
        <Switch>
          <Route exact path='/login' component={LoginPage}/>
          <PrivateRoute path='/' component={App}/>
        </Switch>
      </ThemeComponent>
    )
  }
}

/* Maybe will use later

import DocumentGenContainer from 'containers/ProductDocumentGenerator/index'
<Route path='product'>
  <Route path='generateDoc/:id' components={DocumentGenContainer}/>
</Route>
<Route path='search' component={ProductSearch}/>
<Route path='search' component={ProjectSearch}/>

*/
